/**
 * Auto-generated MDI icon registry — do not edit manually.
 * Re-generate: node scripts/generateMdiIcons.js
 */

import { h, defineComponent } from "vue";
import { VSvgIcon } from "vuetify/lib/composables/icons.js";
import {
  mdiAccount,
  mdiAccountBox,
  mdiAccountCancel,
  mdiAccountCash,
  mdiAccountCheck,
  mdiAccountCircleOutline,
  mdiAccountClock,
  mdiAccountCog,
  mdiAccountEdit,
  mdiAccountGroup,
  mdiAccountLockOutline,
  mdiAccountMultiple,
  mdiAccountOff,
  mdiAccountPlus,
  mdiAccountQuestionOutline,
  mdiAccountRemove,
  mdiAccountTie,
  mdiAirplane,
  mdiAlert,
  mdiAlertCircle,
  mdiAlertCircleOutline,
  mdiAlertOctagon,
  mdiAlertOutline,
  mdiApi,
  mdiApps,
  mdiAppsBox,
  mdiArchive,
  mdiArchiveCheckOutline,
  mdiArrowCollapseVertical,
  mdiArrowDown,
  mdiArrowDownBold,
  mdiArrowExpandVertical,
  mdiArrowLeft,
  mdiArrowRightBold,
  mdiArrowUp,
  mdiBank,
  mdiBankTransfer,
  mdiBankTransferIn,
  mdiBookAccount,
  mdiBookArrowRightOutline,
  mdiBookEditOutline,
  mdiBookOpenPageVariant,
  mdiBookOpenVariant,
  mdiBookshelf,
  mdiBottleSodaOutline,
  mdiBriefcase,
  mdiBriefcaseCheck,
  mdiBriefcaseOff,
  mdiBriefcaseOutline,
  mdiBriefcasePlus,
  mdiBriefcaseRemove,
  mdiBriefcaseSearch,
  mdiBullhorn,
  mdiBullhornOutline,
  mdiCalculator,
  mdiCalculatorVariant,
  mdiCalendar,
  mdiCalendarAccount,
  mdiCalendarBlank,
  mdiCalendarBlankOutline,
  mdiCalendarCheck,
  mdiCalendarCheckOutline,
  mdiCalendarClock,
  mdiCalendarEdit,
  mdiCalendarLock,
  mdiCalendarMinus,
  mdiCalendarMonth,
  mdiCalendarPlus,
  mdiCalendarRange,
  mdiCalendarRemove,
  mdiCalendarToday,
  mdiCalendarWeek,
  mdiCamera,
  mdiCameraOutline,
  mdiCancel,
  mdiCartOutline,
  mdiCash,
  mdiCashCheck,
  mdiCashMinus,
  mdiCashMultiple,
  mdiCashPlus,
  mdiCashRegister,
  mdiCashRemove,
  mdiCellphoneKey,
  mdiChartAreaspline,
  mdiChartBar,
  mdiChartBoxMultipleOutline,
  mdiChartBoxOutline,
  mdiChartLine,
  mdiChartLineVariant,
  mdiChartPie,
  mdiChartTimeline,
  mdiChartTimelineVariant,
  mdiCheck,
  mdiCheckAll,
  mdiCheckCircle,
  mdiCheckCircleOutline,
  mdiCheckbook,
  mdiCheckboxMultipleBlankOutline,
  mdiCheckboxMultipleMarked,
  mdiChefHat,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiCircle,
  mdiCircleHalfFull,
  mdiCircleOutline,
  mdiCity,
  mdiCityVariant,
  mdiClipboardAlertOutline,
  mdiClipboardCheckOutline,
  mdiClipboardList,
  mdiClipboardListOutline,
  mdiClipboardTextOutline,
  mdiClockOutline,
  mdiClose,
  mdiCloseCircle,
  mdiCloudDownload,
  mdiCloudOutline,
  mdiCodeBraces,
  mdiCog,
  mdiCogOff,
  mdiCogOutline,
  mdiCommentEdit,
  mdiCommentPlus,
  mdiCommentRemove,
  mdiCommentTextMultiple,
  mdiCommentTextOutline,
  mdiConsole,
  mdiContentCopy,
  mdiContentDuplicate,
  mdiContentSave,
  mdiContentSaveOutline,
  mdiCounter,
  mdiCreditCardOutline,
  mdiCurrencyUsd,
  mdiDatabase,
  mdiDatabaseEditOutline,
  mdiDatabaseImport,
  mdiDatabasePlus,
  mdiDatabaseRemove,
  mdiDelete,
  mdiDeleteAlert,
  mdiDeleteOutline,
  mdiDeleteSweep,
  mdiDomain,
  mdiDotsVertical,
  mdiDownload,
  mdiDownloadOff,
  mdiDownloadOutline,
  mdiEarth,
  mdiEarthOff,
  mdiEmail,
  mdiEmailArrowRightOutline,
  mdiEmailCheck,
  mdiEmailCheckOutline,
  mdiEmailFast,
  mdiEmailLock,
  mdiEmailOutline,
  mdiEmailSync,
  mdiEqual,
  mdiExport,
  mdiEye,
  mdiEyeCheck,
  mdiEyeOff,
  mdiEyeOffOutline,
  mdiEyeOutline,
  mdiFile,
  mdiFileAccountOutline,
  mdiFileChartOutline,
  mdiFileCheckOutline,
  mdiFileDelimited,
  mdiFileDelimitedOutline,
  mdiFileDocument,
  mdiFileDocumentEditOutline,
  mdiFileDocumentMultiple,
  mdiFileDocumentMultipleOutline,
  mdiFileDocumentOutline,
  mdiFileDownloadOutline,
  mdiFileExcel,
  mdiFileExcelBox,
  mdiFileExcelOutline,
  mdiFileImportOutline,
  mdiFilePdfBox,
  mdiFileRemoveOutline,
  mdiFileReplaceOutline,
  mdiFileTree,
  mdiFileUndoOutline,
  mdiFileUpload,
  mdiFileUploadOutline,
  mdiFileWord,
  mdiFilter,
  mdiFilterOff,
  mdiFilterRemove,
  mdiFilterVariant,
  mdiFlag,
  mdiFolder,
  mdiFolderImage,
  mdiFolderMultiple,
  mdiFolderMultipleImage,
  mdiFolderOpenOutline,
  mdiFolderZip,
  mdiFood,
  mdiFoodApple,
  mdiFoodOutline,
  mdiFoodTakeoutBox,
  mdiFoodVariant,
  mdiFormSelect,
  mdiFormatListBulleted,
  mdiFormatListBulletedType,
  mdiFormatListNumbered,
  mdiGit,
  mdiHandshake,
  mdiHeartPulse,
  mdiHelpCircle,
  mdiHelpCircleOutline,
  mdiHistory,
  mdiHome,
  mdiImage,
  mdiImageMultiple,
  mdiImageMultipleOutline,
  mdiImageOutline,
  mdiImagePlus,
  mdiImageRefresh,
  mdiImport,
  mdiInformation,
  mdiInformationOutline,
  mdiKey,
  mdiKeyAlert,
  mdiKeyChain,
  mdiKeyChange,
  mdiKeyPlus,
  mdiKeyRemove,
  mdiKeyVariant,
  mdiLink,
  mdiLinkOff,
  mdiLinkPlus,
  mdiLoading,
  mdiLock,
  mdiLockCheck,
  mdiLockCheckOutline,
  mdiLockOpen,
  mdiLockOutline,
  mdiLockReset,
  mdiLogin,
  mdiLogout,
  mdiLogoutVariant,
  mdiMagnify,
  mdiMap,
  mdiMapMarker,
  mdiMapMarkerCheck,
  mdiMapMarkerMultiple,
  mdiMapMarkerOff,
  mdiMapPlus,
  mdiMapSearch,
  mdiMenu,
  mdiMessageTextOutline,
  mdiMicrosoftExcel,
  mdiMinusCircle,
  mdiMonitor,
  mdiMusic,
  mdiNotePlusOutline,
  mdiNoteTextOutline,
  mdiNotebookOutline,
  mdiOfficeBuildingOutline,
  mdiOpenInNew,
  mdiPackageVariant,
  mdiPackageVariantClosed,
  mdiPalette,
  mdiPaperclip,
  mdiPause,
  mdiPencil,
  mdiPencilOff,
  mdiPhone,
  mdiPhoneAlert,
  mdiPlay,
  mdiPlus,
  mdiPlusCircle,
  mdiPlusCircleMultiple,
  mdiPlusCircleOutline,
  mdiPresentation,
  mdiReceiptTextOutline,
  mdiRefresh,
  mdiRefreshCircle,
  mdiRestore,
  mdiRocketLaunchOutline,
  mdiSale,
  mdiScaleBalance,
  mdiSend,
  mdiShapeOutline,
  mdiShareVariant,
  mdiShareVariantOutline,
  mdiShieldKey,
  mdiShieldLock,
  mdiShieldOff,
  mdiShuffle,
  mdiShuffleVariant,
  mdiSigma,
  mdiSilverwareForkKnife,
  mdiSitemap,
  mdiSourceBranch,
  mdiStar,
  mdiStarOutline,
  mdiStore,
  mdiStoreOffOutline,
  mdiStorefront,
  mdiStorefrontOutline,
  mdiSvg,
  mdiSwapHorizontal,
  mdiTable,
  mdiTableCheck,
  mdiTableCog,
  mdiTableColumn,
  mdiTableEdit,
  mdiTablePlus,
  mdiTableRemove,
  mdiTableSearch,
  mdiTag,
  mdiTagEdit,
  mdiTagMultiple,
  mdiTagMultipleOutline,
  mdiTagOff,
  mdiTagOffOutline,
  mdiTagPlus,
  mdiTagRemove,
  mdiTarget,
  mdiTestTube,
  mdiTextBoxEdit,
  mdiTextSearch,
  mdiTextSearchVariant,
  mdiThemeLightDark,
  mdiTimelineClock,
  mdiTimerCheck,
  mdiTimerOff,
  mdiTimerRefresh,
  mdiToggleSwitch,
  mdiToggleSwitchOff,
  mdiToggleSwitchOutline,
  mdiTrashCanOutline,
  mdiTruck,
  mdiTruckDelivery,
  mdiTruckOutline,
  mdiTune,
  mdiUndoVariant,
  mdiUnfoldLessHorizontal,
  mdiUnfoldMoreHorizontal,
  mdiUpload,
  mdiUploadOff,
  mdiVideo,
  mdiViewDashboard,
  mdiViewGrid,
  mdiViewList,
  mdiWarehouse,
  mdiWeatherNight,
  mdiWeatherSunny,
  mdiWhatsapp,
  mdiWizardHat,
  mdiWrench,
} from "@mdi/js";

const icons = {
  "mdi-account": mdiAccount,
  "mdi-account-box": mdiAccountBox,
  "mdi-account-cancel": mdiAccountCancel,
  "mdi-account-cash": mdiAccountCash,
  "mdi-account-check": mdiAccountCheck,
  "mdi-account-circle-outline": mdiAccountCircleOutline,
  "mdi-account-clock": mdiAccountClock,
  "mdi-account-cog": mdiAccountCog,
  "mdi-account-edit": mdiAccountEdit,
  "mdi-account-group": mdiAccountGroup,
  "mdi-account-lock-outline": mdiAccountLockOutline,
  "mdi-account-multiple": mdiAccountMultiple,
  "mdi-account-off": mdiAccountOff,
  "mdi-account-plus": mdiAccountPlus,
  "mdi-account-question-outline": mdiAccountQuestionOutline,
  "mdi-account-remove": mdiAccountRemove,
  "mdi-account-tie": mdiAccountTie,
  "mdi-airplane": mdiAirplane,
  "mdi-alert": mdiAlert,
  "mdi-alert-circle": mdiAlertCircle,
  "mdi-alert-circle-outline": mdiAlertCircleOutline,
  "mdi-alert-octagon": mdiAlertOctagon,
  "mdi-alert-outline": mdiAlertOutline,
  "mdi-api": mdiApi,
  "mdi-apps": mdiApps,
  "mdi-apps-box": mdiAppsBox,
  "mdi-archive": mdiArchive,
  "mdi-archive-check-outline": mdiArchiveCheckOutline,
  "mdi-arrow-collapse-vertical": mdiArrowCollapseVertical,
  "mdi-arrow-down": mdiArrowDown,
  "mdi-arrow-down-bold": mdiArrowDownBold,
  "mdi-arrow-expand-vertical": mdiArrowExpandVertical,
  "mdi-arrow-left": mdiArrowLeft,
  "mdi-arrow-right-bold": mdiArrowRightBold,
  "mdi-arrow-up": mdiArrowUp,
  "mdi-bank": mdiBank,
  "mdi-bank-transfer": mdiBankTransfer,
  "mdi-bank-transfer-in": mdiBankTransferIn,
  "mdi-book-account": mdiBookAccount,
  "mdi-book-arrow-right-outline": mdiBookArrowRightOutline,
  "mdi-book-edit-outline": mdiBookEditOutline,
  "mdi-book-open-page-variant": mdiBookOpenPageVariant,
  "mdi-book-open-variant": mdiBookOpenVariant,
  "mdi-bookshelf": mdiBookshelf,
  "mdi-bottle-soda-outline": mdiBottleSodaOutline,
  "mdi-briefcase": mdiBriefcase,
  "mdi-briefcase-check": mdiBriefcaseCheck,
  "mdi-briefcase-off": mdiBriefcaseOff,
  "mdi-briefcase-outline": mdiBriefcaseOutline,
  "mdi-briefcase-plus": mdiBriefcasePlus,
  "mdi-briefcase-remove": mdiBriefcaseRemove,
  "mdi-briefcase-search": mdiBriefcaseSearch,
  "mdi-bullhorn": mdiBullhorn,
  "mdi-bullhorn-outline": mdiBullhornOutline,
  "mdi-calculator": mdiCalculator,
  "mdi-calculator-variant": mdiCalculatorVariant,
  "mdi-calendar": mdiCalendar,
  "mdi-calendar-account": mdiCalendarAccount,
  "mdi-calendar-blank": mdiCalendarBlank,
  "mdi-calendar-blank-outline": mdiCalendarBlankOutline,
  "mdi-calendar-check": mdiCalendarCheck,
  "mdi-calendar-check-outline": mdiCalendarCheckOutline,
  "mdi-calendar-clock": mdiCalendarClock,
  "mdi-calendar-edit": mdiCalendarEdit,
  "mdi-calendar-lock": mdiCalendarLock,
  "mdi-calendar-minus": mdiCalendarMinus,
  "mdi-calendar-month": mdiCalendarMonth,
  "mdi-calendar-plus": mdiCalendarPlus,
  "mdi-calendar-range": mdiCalendarRange,
  "mdi-calendar-remove": mdiCalendarRemove,
  "mdi-calendar-today": mdiCalendarToday,
  "mdi-calendar-week": mdiCalendarWeek,
  "mdi-camera": mdiCamera,
  "mdi-camera-outline": mdiCameraOutline,
  "mdi-cancel": mdiCancel,
  "mdi-cart-outline": mdiCartOutline,
  "mdi-cash": mdiCash,
  "mdi-cash-check": mdiCashCheck,
  "mdi-cash-minus": mdiCashMinus,
  "mdi-cash-multiple": mdiCashMultiple,
  "mdi-cash-plus": mdiCashPlus,
  "mdi-cash-register": mdiCashRegister,
  "mdi-cash-remove": mdiCashRemove,
  "mdi-cellphone-key": mdiCellphoneKey,
  "mdi-chart-areaspline": mdiChartAreaspline,
  "mdi-chart-bar": mdiChartBar,
  "mdi-chart-box-multiple-outline": mdiChartBoxMultipleOutline,
  "mdi-chart-box-outline": mdiChartBoxOutline,
  "mdi-chart-line": mdiChartLine,
  "mdi-chart-line-variant": mdiChartLineVariant,
  "mdi-chart-pie": mdiChartPie,
  "mdi-chart-timeline": mdiChartTimeline,
  "mdi-chart-timeline-variant": mdiChartTimelineVariant,
  "mdi-check": mdiCheck,
  "mdi-check-all": mdiCheckAll,
  "mdi-check-circle": mdiCheckCircle,
  "mdi-check-circle-outline": mdiCheckCircleOutline,
  "mdi-checkbook": mdiCheckbook,
  "mdi-checkbox-multiple-blank-outline": mdiCheckboxMultipleBlankOutline,
  "mdi-checkbox-multiple-marked": mdiCheckboxMultipleMarked,
  "mdi-chef-hat": mdiChefHat,
  "mdi-chevron-down": mdiChevronDown,
  "mdi-chevron-left": mdiChevronLeft,
  "mdi-chevron-right": mdiChevronRight,
  "mdi-chevron-up": mdiChevronUp,
  "mdi-circle": mdiCircle,
  "mdi-circle-half-full": mdiCircleHalfFull,
  "mdi-circle-outline": mdiCircleOutline,
  "mdi-city": mdiCity,
  "mdi-city-variant": mdiCityVariant,
  "mdi-clipboard-alert-outline": mdiClipboardAlertOutline,
  "mdi-clipboard-check-outline": mdiClipboardCheckOutline,
  "mdi-clipboard-list": mdiClipboardList,
  "mdi-clipboard-list-outline": mdiClipboardListOutline,
  "mdi-clipboard-text-outline": mdiClipboardTextOutline,
  "mdi-clock-outline": mdiClockOutline,
  "mdi-close": mdiClose,
  "mdi-close-circle": mdiCloseCircle,
  "mdi-cloud-download": mdiCloudDownload,
  "mdi-cloud-outline": mdiCloudOutline,
  "mdi-code-braces": mdiCodeBraces,
  "mdi-cog": mdiCog,
  "mdi-cog-off": mdiCogOff,
  "mdi-cog-outline": mdiCogOutline,
  "mdi-comment-edit": mdiCommentEdit,
  "mdi-comment-plus": mdiCommentPlus,
  "mdi-comment-remove": mdiCommentRemove,
  "mdi-comment-text-multiple": mdiCommentTextMultiple,
  "mdi-comment-text-outline": mdiCommentTextOutline,
  "mdi-console": mdiConsole,
  "mdi-content-copy": mdiContentCopy,
  "mdi-content-duplicate": mdiContentDuplicate,
  "mdi-content-save": mdiContentSave,
  "mdi-content-save-outline": mdiContentSaveOutline,
  "mdi-counter": mdiCounter,
  "mdi-credit-card-outline": mdiCreditCardOutline,
  "mdi-currency-usd": mdiCurrencyUsd,
  "mdi-database": mdiDatabase,
  "mdi-database-edit-outline": mdiDatabaseEditOutline,
  "mdi-database-import": mdiDatabaseImport,
  "mdi-database-plus": mdiDatabasePlus,
  "mdi-database-remove": mdiDatabaseRemove,
  "mdi-delete": mdiDelete,
  "mdi-delete-alert": mdiDeleteAlert,
  "mdi-delete-outline": mdiDeleteOutline,
  "mdi-delete-sweep": mdiDeleteSweep,
  "mdi-domain": mdiDomain,
  "mdi-dots-vertical": mdiDotsVertical,
  "mdi-download": mdiDownload,
  "mdi-download-off": mdiDownloadOff,
  "mdi-download-outline": mdiDownloadOutline,
  "mdi-earth": mdiEarth,
  "mdi-earth-off": mdiEarthOff,
  "mdi-email": mdiEmail,
  "mdi-email-arrow-right-outline": mdiEmailArrowRightOutline,
  "mdi-email-check": mdiEmailCheck,
  "mdi-email-check-outline": mdiEmailCheckOutline,
  "mdi-email-fast": mdiEmailFast,
  "mdi-email-lock": mdiEmailLock,
  "mdi-email-outline": mdiEmailOutline,
  "mdi-email-sync": mdiEmailSync,
  "mdi-equal": mdiEqual,
  "mdi-export": mdiExport,
  "mdi-eye": mdiEye,
  "mdi-eye-check": mdiEyeCheck,
  "mdi-eye-off": mdiEyeOff,
  "mdi-eye-off-outline": mdiEyeOffOutline,
  "mdi-eye-outline": mdiEyeOutline,
  "mdi-file": mdiFile,
  "mdi-file-account-outline": mdiFileAccountOutline,
  "mdi-file-chart-outline": mdiFileChartOutline,
  "mdi-file-check-outline": mdiFileCheckOutline,
  "mdi-file-delimited": mdiFileDelimited,
  "mdi-file-delimited-outline": mdiFileDelimitedOutline,
  "mdi-file-document": mdiFileDocument,
  "mdi-file-document-edit-outline": mdiFileDocumentEditOutline,
  "mdi-file-document-multiple": mdiFileDocumentMultiple,
  "mdi-file-document-multiple-outline": mdiFileDocumentMultipleOutline,
  "mdi-file-document-outline": mdiFileDocumentOutline,
  "mdi-file-download-outline": mdiFileDownloadOutline,
  "mdi-file-excel": mdiFileExcel,
  "mdi-file-excel-box": mdiFileExcelBox,
  "mdi-file-excel-outline": mdiFileExcelOutline,
  "mdi-file-import-outline": mdiFileImportOutline,
  "mdi-file-pdf-box": mdiFilePdfBox,
  "mdi-file-remove-outline": mdiFileRemoveOutline,
  "mdi-file-replace-outline": mdiFileReplaceOutline,
  "mdi-file-tree": mdiFileTree,
  "mdi-file-undo-outline": mdiFileUndoOutline,
  "mdi-file-upload": mdiFileUpload,
  "mdi-file-upload-outline": mdiFileUploadOutline,
  "mdi-file-word": mdiFileWord,
  "mdi-filter": mdiFilter,
  "mdi-filter-off": mdiFilterOff,
  "mdi-filter-remove": mdiFilterRemove,
  "mdi-filter-variant": mdiFilterVariant,
  "mdi-flag": mdiFlag,
  "mdi-folder": mdiFolder,
  "mdi-folder-image": mdiFolderImage,
  "mdi-folder-multiple": mdiFolderMultiple,
  "mdi-folder-multiple-image": mdiFolderMultipleImage,
  "mdi-folder-open-outline": mdiFolderOpenOutline,
  "mdi-folder-zip": mdiFolderZip,
  "mdi-food": mdiFood,
  "mdi-food-apple": mdiFoodApple,
  "mdi-food-outline": mdiFoodOutline,
  "mdi-food-takeout-box": mdiFoodTakeoutBox,
  "mdi-food-variant": mdiFoodVariant,
  "mdi-form-select": mdiFormSelect,
  "mdi-format-list-bulleted": mdiFormatListBulleted,
  "mdi-format-list-bulleted-type": mdiFormatListBulletedType,
  "mdi-format-list-numbered": mdiFormatListNumbered,
  "mdi-git": mdiGit,
  "mdi-handshake": mdiHandshake,
  "mdi-heart-pulse": mdiHeartPulse,
  "mdi-help-circle": mdiHelpCircle,
  "mdi-help-circle-outline": mdiHelpCircleOutline,
  "mdi-history": mdiHistory,
  "mdi-home": mdiHome,
  "mdi-image": mdiImage,
  "mdi-image-multiple": mdiImageMultiple,
  "mdi-image-multiple-outline": mdiImageMultipleOutline,
  "mdi-image-outline": mdiImageOutline,
  "mdi-image-plus": mdiImagePlus,
  "mdi-image-refresh": mdiImageRefresh,
  "mdi-import": mdiImport,
  "mdi-information": mdiInformation,
  "mdi-information-outline": mdiInformationOutline,
  "mdi-key": mdiKey,
  "mdi-key-alert": mdiKeyAlert,
  "mdi-key-chain": mdiKeyChain,
  "mdi-key-change": mdiKeyChange,
  "mdi-key-plus": mdiKeyPlus,
  "mdi-key-remove": mdiKeyRemove,
  "mdi-key-variant": mdiKeyVariant,
  "mdi-link": mdiLink,
  "mdi-link-off": mdiLinkOff,
  "mdi-link-plus": mdiLinkPlus,
  "mdi-loading": mdiLoading,
  "mdi-lock": mdiLock,
  "mdi-lock-check": mdiLockCheck,
  "mdi-lock-check-outline": mdiLockCheckOutline,
  "mdi-lock-open": mdiLockOpen,
  "mdi-lock-outline": mdiLockOutline,
  "mdi-lock-reset": mdiLockReset,
  "mdi-login": mdiLogin,
  "mdi-logout": mdiLogout,
  "mdi-logout-variant": mdiLogoutVariant,
  "mdi-magnify": mdiMagnify,
  "mdi-map": mdiMap,
  "mdi-map-marker": mdiMapMarker,
  "mdi-map-marker-check": mdiMapMarkerCheck,
  "mdi-map-marker-multiple": mdiMapMarkerMultiple,
  "mdi-map-marker-off": mdiMapMarkerOff,
  "mdi-map-plus": mdiMapPlus,
  "mdi-map-search": mdiMapSearch,
  "mdi-menu": mdiMenu,
  "mdi-message-text-outline": mdiMessageTextOutline,
  "mdi-microsoft-excel": mdiMicrosoftExcel,
  "mdi-minus-circle": mdiMinusCircle,
  "mdi-monitor": mdiMonitor,
  "mdi-music": mdiMusic,
  "mdi-note-plus-outline": mdiNotePlusOutline,
  "mdi-note-text-outline": mdiNoteTextOutline,
  "mdi-notebook-outline": mdiNotebookOutline,
  "mdi-office-building-outline": mdiOfficeBuildingOutline,
  "mdi-open-in-new": mdiOpenInNew,
  "mdi-package-variant": mdiPackageVariant,
  "mdi-package-variant-closed": mdiPackageVariantClosed,
  "mdi-palette": mdiPalette,
  "mdi-paperclip": mdiPaperclip,
  "mdi-pause": mdiPause,
  "mdi-pencil": mdiPencil,
  "mdi-pencil-off": mdiPencilOff,
  "mdi-phone": mdiPhone,
  "mdi-phone-alert": mdiPhoneAlert,
  "mdi-play": mdiPlay,
  "mdi-plus": mdiPlus,
  "mdi-plus-circle": mdiPlusCircle,
  "mdi-plus-circle-multiple": mdiPlusCircleMultiple,
  "mdi-plus-circle-outline": mdiPlusCircleOutline,
  "mdi-presentation": mdiPresentation,
  "mdi-receipt-text-outline": mdiReceiptTextOutline,
  "mdi-refresh": mdiRefresh,
  "mdi-refresh-circle": mdiRefreshCircle,
  "mdi-restore": mdiRestore,
  "mdi-rocket-launch-outline": mdiRocketLaunchOutline,
  "mdi-sale": mdiSale,
  "mdi-scale-balance": mdiScaleBalance,
  "mdi-send": mdiSend,
  "mdi-shape-outline": mdiShapeOutline,
  "mdi-share-variant": mdiShareVariant,
  "mdi-share-variant-outline": mdiShareVariantOutline,
  "mdi-shield-key": mdiShieldKey,
  "mdi-shield-lock": mdiShieldLock,
  "mdi-shield-off": mdiShieldOff,
  "mdi-shuffle": mdiShuffle,
  "mdi-shuffle-variant": mdiShuffleVariant,
  "mdi-sigma": mdiSigma,
  "mdi-silverware-fork-knife": mdiSilverwareForkKnife,
  "mdi-sitemap": mdiSitemap,
  "mdi-source-branch": mdiSourceBranch,
  "mdi-star": mdiStar,
  "mdi-star-outline": mdiStarOutline,
  "mdi-store": mdiStore,
  "mdi-store-off-outline": mdiStoreOffOutline,
  "mdi-storefront": mdiStorefront,
  "mdi-storefront-outline": mdiStorefrontOutline,
  "mdi-svg": mdiSvg,
  "mdi-swap-horizontal": mdiSwapHorizontal,
  "mdi-table": mdiTable,
  "mdi-table-check": mdiTableCheck,
  "mdi-table-cog": mdiTableCog,
  "mdi-table-column": mdiTableColumn,
  "mdi-table-edit": mdiTableEdit,
  "mdi-table-plus": mdiTablePlus,
  "mdi-table-remove": mdiTableRemove,
  "mdi-table-search": mdiTableSearch,
  "mdi-tag": mdiTag,
  "mdi-tag-edit": mdiTagEdit,
  "mdi-tag-multiple": mdiTagMultiple,
  "mdi-tag-multiple-outline": mdiTagMultipleOutline,
  "mdi-tag-off": mdiTagOff,
  "mdi-tag-off-outline": mdiTagOffOutline,
  "mdi-tag-plus": mdiTagPlus,
  "mdi-tag-remove": mdiTagRemove,
  "mdi-target": mdiTarget,
  "mdi-test-tube": mdiTestTube,
  "mdi-text-box-edit": mdiTextBoxEdit,
  "mdi-text-search": mdiTextSearch,
  "mdi-text-search-variant": mdiTextSearchVariant,
  "mdi-theme-light-dark": mdiThemeLightDark,
  "mdi-timeline-clock": mdiTimelineClock,
  "mdi-timer-check": mdiTimerCheck,
  "mdi-timer-off": mdiTimerOff,
  "mdi-timer-refresh": mdiTimerRefresh,
  "mdi-toggle-switch": mdiToggleSwitch,
  "mdi-toggle-switch-off": mdiToggleSwitchOff,
  "mdi-toggle-switch-outline": mdiToggleSwitchOutline,
  "mdi-trash-can-outline": mdiTrashCanOutline,
  "mdi-truck": mdiTruck,
  "mdi-truck-delivery": mdiTruckDelivery,
  "mdi-truck-outline": mdiTruckOutline,
  "mdi-tune": mdiTune,
  "mdi-undo-variant": mdiUndoVariant,
  "mdi-unfold-less-horizontal": mdiUnfoldLessHorizontal,
  "mdi-unfold-more-horizontal": mdiUnfoldMoreHorizontal,
  "mdi-upload": mdiUpload,
  "mdi-upload-off": mdiUploadOff,
  "mdi-video": mdiVideo,
  "mdi-view-dashboard": mdiViewDashboard,
  "mdi-view-grid": mdiViewGrid,
  "mdi-view-list": mdiViewList,
  "mdi-warehouse": mdiWarehouse,
  "mdi-weather-night": mdiWeatherNight,
  "mdi-weather-sunny": mdiWeatherSunny,
  "mdi-whatsapp": mdiWhatsapp,
  "mdi-wizard-hat": mdiWizardHat,
  "mdi-wrench": mdiWrench,
};

const mdiSvgComponent = defineComponent({
  name: "MdiSvgResolver",
  props: { icon: { required: true }, tag: { default: "i" } },
  setup(props, { attrs }) {
    return () => {
      const resolved = icons[props.icon] || (typeof props.icon === "string" && /^[Mm]/.test(props.icon) ? props.icon : null);
      if (!resolved) {
        if (import.meta.env.DEV) {
          console.warn(`[mdiIcons] Unknown icon: "${props.icon}" — add it to scripts/generateMdiIcons.js and re-run`);
        }
        return null;
      }
      return h(VSvgIcon, { ...attrs, icon: resolved, tag: props.tag });
    };
  },
});

export const mdiSvgSet = {
  component: mdiSvgComponent,
};
